import Pipelines from './Pipelines';

export default Pipelines;
